import React from "react";

import { HStack } from "@/components/ui";
import { cn } from "@/utils/cn";

import PlaceholderAvatar from "./placeholder-avatar";
import PlaceholderDisplayName from "./placeholder-display-name";
import PlaceholderStatusContent from "./placeholder-status-content";

interface PlaceholderStatusProps {
  variant?: "rounded-sm" | "slim" | "default";
}

/** Fake status to display while data is loading. */
const PlaceholderStatus: React.FC<PlaceholderStatusProps> = ({ variant }) => (
  <div
    className={cn("status-placeholder", {
      "p-4": variant !== "slim",
      "py-4": variant === "slim",
    })}
  >
    <div className="w-full animate-pulse overflow-hidden">
      <div>
        <HStack space={3} alignItems="center">
          <div className="shrink-0">
            <PlaceholderAvatar size={42} />
          </div>

          <div className="min-w-0 flex-1">
            <PlaceholderDisplayName minLength={3} maxLength={25} />
          </div>
        </HStack>
      </div>

      <div className="mt-4">
        <PlaceholderStatusContent minLength={5} maxLength={120} />
      </div>
    </div>
  </div>
);

export default React.memo(PlaceholderStatus);
